<template>
    <span>{{ row.PaymentPoolStatusStr || '-' }}</span>
</template>

<script>
export default{
    props:{
        fields:[String,Number],
        row:Object
    },
}
</script>